module.exports = __webpack_public_path__ + "img/9.7567e760.png";